/**
 * @generated SignedSource<<936c2ae6643cbc6331ec24dcd9168f13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Entitlement = "advanced_analytics" | "ai_bot" | "ai_content_generation" | "ai_image_generation" | "ai_inline_prompts" | "ai_subtitle" | "ai_video_transcription" | "brand_customization" | "bulk_invite" | "custom_domains" | "custom_profile_fields" | "disable_cookie_consent" | "memberships" | "multiple_zoom_accounts" | "prerequisites" | "quizzes" | "saml_sso" | "scorm" | "slack_integration" | "webhooks" | "whitelabel" | "zapier_integration" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useHasEntitlementActiveOrganizationFragment$data = {
  readonly entitlements: ReadonlyArray<Entitlement>;
  readonly " $fragmentType": "useHasEntitlementActiveOrganizationFragment";
};
export type useHasEntitlementActiveOrganizationFragment$key = {
  readonly " $data"?: useHasEntitlementActiveOrganizationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHasEntitlementActiveOrganizationFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useHasEntitlementActiveOrganizationFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entitlements",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "118106e9186f493ad575d8af93f6b94c";

export default node;
